export {
	getTenantId,
	setTenantId,
	getTenantIdCookie,
} from '@innovyze/lib_get_service';
export { default as useInferTenantId } from './useInferTenantId';
